import * as React from 'react';
const EmatomaCutaneoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M132.12 114.28c1.5-.94 2.99-1.94 4.48-2.99M63.61 65.88c3.49 13.72 2.1 22.53 5.3 32.87s5.94 15.82 6.3 19.84 1 15.05 13.06 12.41c.43-.09.87-.19 1.32-.29M81.06 62.23c4.68 13.15 11.18 22.01 14.36 31.15s0 11.2 0 11.2"
      className="prefix__cls-2"
    />
    <path
      d="M132.58 75.93s-22.84 14.8-26.31 17.63-7.8 4.91-10.09 2.32"
      className="prefix__cls-2"
    />
    <circle cx={112.32} cy={124.43} r={8.66} className="prefix__cls-1" />
    <circle cx={112.32} cy={124.43} r={1.24} className="prefix__cls-1" />
    <circle cx={112.32} cy={124.43} r={16.14} className="prefix__cls-1" />
  </svg>
);
export default EmatomaCutaneoIcon;
